import React from 'react'
import PropTypes from 'prop-types'

import {
  WaypointWrapper,
  WaypointTitleWrapper,
  WaypointTitle,
  WaypointCaption,
  WaypointIconRight,
  WaypointContentWrapper,
  PickupPinIcon,
  DropoffPinIcon,
} from './waypoint.styles'

const Waypoint = props => {
  const {
    caption,
    anchor,
    isStopover,
    isDestination,
    children,
    dataTestid,
    className,
    isCollapsed,
    iconRight,
  } = props

  const title = anchor || <WaypointCaption>{caption}</WaypointCaption>

  const content = (
    <WaypointContentWrapper isDestination={isDestination} hasIconRight={!!iconRight}>
      {children}
    </WaypointContentWrapper>
  )

  return (
    <WaypointWrapper className={className} data-testid={dataTestid} draggingOver={props.draggingOver} isDragging={props.isDragging} >
      <WaypointTitleWrapper
        hasCaption={!anchor}
        isStopover={isStopover}
        isDestination={isDestination}
      >
        {isStopover || isDestination ? <DropoffPinIcon /> : <PickupPinIcon />}
        <WaypointTitle hasIcon={!!iconRight}>{title}</WaypointTitle>
        {iconRight && <WaypointIconRight>{iconRight}</WaypointIconRight>}
      </WaypointTitleWrapper>
      { !isCollapsed && content }
    </WaypointWrapper>
  )
}

Waypoint.displayName = 'Waypoint'

Waypoint.propTypes = {
  caption: PropTypes.string,
  anchor: PropTypes.node,
  isStopover: PropTypes.bool,
  isDestination: PropTypes.bool,
  children: PropTypes.node,
  dataTestid: PropTypes.string,
  className: PropTypes.string,
  isCollapsed: PropTypes.bool,
  iconRight: PropTypes.node,
  isDragging: PropTypes.bool,
  draggingOver: PropTypes.string
}

Waypoint.defaultProps = {
  isStopover: false,
  isDestination: false,
  isCollapsed: false,
}

export { Waypoint }
